export const actionTypes = {
  GET_USER_LIST_PENDING: "GET_USER_LIST_PENDING",
  GET_USER_LIST_SUCCESS: "GET_USER_LIST_SUCCESS",
  GET_USER_LIST_ERROR: "GET_USER_LIST_ERROR",

  ADD_NEW_USER_PENDING: "ADD_NEW_USER_PENDING",
  ADD_NEW_USER_SUCCESS: "ADD_NEW_USER_SUCCESS",
  ADD_NEW_USER_ERROR: "ADD_NEW_USER_ERROR",

  EDIT_USER_PENDING: "EDIT_USER_PENDING",
  EDIT_USER_SUCCESS: "EDIT_USER_SUCCESS",
  EDIT_USER_ERROR: "EDIT_USER_ERROR",

  DELETE_USER_PENDING: "DELETE_USER_PENDING",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_ERROR: "DELETE_USER_ERROR",

  UPDATE_CURRENT_PAGE: "UPDATE_CURRENT_PAGE",

  UPDATE_ROWS_PER_PAGE: "UPDATE_ROWS_PER_PAGE",

  UPDATE_ADMIN_SEARCH_FILTERS: "UPDATE_ADMIN_SEARCH_FILTERS",
};

const initialState = {
  getUserListPending: false,
  getUserListSuccess: false,
  getUserListError: null,

  addNewUserPending: false,
  addNewUserSuccess: false,
  addNewUserError: null,

  editUserPending: false,
  editUserSuccess: false,
  editUserError: null,

  deleteUserPending: false,
  deleteUserSuccess: false,
  deleteUserError: null,

  userList: [],
  searchValue: "",
  fields: {
    searchValue: "",
  },
  currentPage: 1,
  rowsPerPage: { label: "10", value: 10 },
};

export default function userManagement(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_USER_LIST_PENDING:
    case actionTypes.GET_USER_LIST_SUCCESS:
    case actionTypes.GET_USER_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_NEW_USER_PENDING:
    case actionTypes.ADD_NEW_USER_SUCCESS:
    case actionTypes.ADD_NEW_USER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.EDIT_USER_PENDING:
    case actionTypes.EDIT_USER_SUCCESS:
    case actionTypes.EDIT_USER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.DELETE_USER_PENDING:
    case actionTypes.DELETE_USER_SUCCESS:
    case actionTypes.DELETE_USER_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ROWS_PER_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_CURRENT_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ADMIN_SEARCH_FILTERS:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
